export default __webpack_public_path__ + "static/media/reporting-planet.e36b2701.png";